






import { Component, Prop, Vue } from 'vue-property-decorator';
import UnitGroupingCharts from '@/components/Overlays/Additions/UnitGroupingCharts.vue';

@Component({
    components: {
        UnitGroupingCharts,
    },
})
export default class OverlayAddition extends Vue {
    @Prop() public componentName: string;
    @Prop() public componentHeight: number;

    constructor() {
        super();
    }
}
